<template>
  <v-container>
    <v-btn color="primary" text class="text-h5 mt-10" @click="goBack()">
      <v-icon left>mdi-arrow-left</v-icon>
      {{ $t("common.back") }}
    </v-btn>
    <v-row class="text-h2 justify-center pa-10">
      {{ $t(`molecule.${update ? "update" : add ? "add" : "show"}.title`) }}
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="validate"
      :readonly="show"
    >
      <v-row class="justify-center">
        <v-col cols="12" sm="6" class="justify-end">
          <v-select
            v-model="molecule.type"
            :label="$t('common.select')"
            :item-text="'name'"
            :item-value="'value'"
            :items="moleculeTypes"
            variant="underlined"
          ></v-select>
          <v-text-field
            v-model="molecule.name"
            :rules="[(v) => !!v || $t('molecule.form.error.name')]"
            :label="$t('molecule.form.label.name')"
            required
          ></v-text-field>
          <v-text-field
            v-model="molecule.casNumber"
            :label="$t('molecule.form.label.casNumber')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.chemicalFormula"
            :label="$t('molecule.form.label.chemicalFormula')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.generalTaste"
            :label="$t('molecule.form.label.generalTaste')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.unamiPerception"
            :label="$t('molecule.form.label.umamiPerception')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.other"
            :label="$t('molecule.form.label.other')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.dosage"
            :label="$t('molecule.form.label.dosage')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.process"
            :label="$t('molecule.form.label.process')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.labelling"
            :label="$t('molecule.form.label.labelling')"
          ></v-text-field>
          <v-text-field
            v-model="molecule.biologicalSource"
            :label="$t('molecule.form.label.biologicalSource')"
          ></v-text-field>
          <v-autocomplete
            :items="families"
            v-model="molecule.families"
            :label="$t('molecule.form.label.families')"
            multiple
            chips
            deletable-chips
            return-object
            item-text="name"
            :append-icon="!show ? 'mdi-menu-down' : ''"
          ></v-autocomplete>
          <v-autocomplete
            :items="sources"
            v-model="molecule.sources"
            :label="$t('molecule.form.label.sources')"
            multiple
            chips
            return-object
            deletable-chips
            item-text="title"
            :append-icon="!show ? 'mdi-menu-down' : ''"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-form>
    <v-row class="justify-center">
      <v-btn
        v-if="!show"
        :disabled="!valid"
        color="success"
        class="ma-4"
        @click="validate"
      >
        {{ $t(`molecule.button.${update ? "update" : "add"}`) }}
      </v-btn>
      <v-btn
        v-if="this.update"
        :disabled="!valid"
        color="error"
        class="ma-4"
        @click="deleteItem"
      >
        {{ $t(`molecule.button.delete`) }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router";
import { useMoleculeStore } from "@/store/moleculeStore";
import Vue, { ref } from "vue";
import { storeToRefs } from "pinia";
import { useFamilyStore } from "@/store/familyStore";
import { useSourceStore } from "@/store/sourceStore";
import i18n from "@/i18n";
import { POSITION, TYPE } from "vue-toastification";
import { useUserStore } from "@/store/userStore";

export default {
  data: () => ({
    valid: true,
    store: useMoleculeStore(),
    userStore: useUserStore(),
    familyStore: useFamilyStore(),
    sourceStore: useSourceStore(),
    molecule: ref(null),
    families: ref([]),
    sources: ref([]),
    moleculeTypes: [],
  }),
  props: {
    add: Boolean,
    update: Boolean,
    show: Boolean,
  },
  beforeMount() {
    this.moleculeTypes = [
      {
        name: this.$t("molecule.list.typeFilter.MOLECULE_STANDARD"),
        value: "MOLECULE_STANDARD",
      },
      {
        name: this.$t("molecule.list.typeFilter.MOLECULE_KOKUMI"),
        value: "MOLECULE_KOKUMI",
      },
    ];
    console.log(this.update || this.add);
    if ((this.update || this.add) && !this.userStore.isWriter()) {
      Vue.$toast(i18n.t("molecule.toast.access.error"), {
        timeout: 2000,
        position: POSITION.TOP_CENTER,
        type: TYPE.ERROR,
      });
      this.goBack();
      return;
    }
    this.molecule = storeToRefs(this.store).molecule;
    this.families = storeToRefs(this.familyStore).families;
    this.sources = storeToRefs(this.sourceStore).sources;
    this.familyStore.getFamilies();
    this.sourceStore.getSources();
    if (!this.add) {
      this.store.getMoleculeById(parseInt(router.currentRoute.params.id));
    }
  },
  methods: {
    validate() {
      if (!this.show && this.$refs.form.validate()) {
        if (this.update) {
          this.store.updateMolecule().then(() => this.goBack());
        } else {
          this.store.addMolecule().then(() => this.goBack());
        }
      }
    },
    goBack() {
      this.store.$reset();
      router.go(-1);
    },
    deleteItem() {
      if (confirm(this.$t("molecule.delete.confirm"))) {
        this.store.deleteMolecule(this.molecule.id);
        this.goBack();
      }
    },
  },
};
</script>
